export function trackEvent(name, properties = {}, opts = {}) {
  fetch("/track_event", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, properties, opts }),
  });
}

export function trackPageView(page, args = {}) {
  fetch("/track_event", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: "page_viewed",
      properties: { page, ...args },
    }),
  });
}
